import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-labour-salary-type',
  templateUrl: './labour-salary-type.component.html',
  styleUrls: ['./labour-salary-type.component.css']
})
export class LabourSalaryTypeComponent implements OnInit {
    labourSalaryTypeKeyno;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.labourSalaryTypeKeyno = this.stateService.getStateParams()['laboursalarytype_keyno'];
    }

    private async loadEdit() {
        if (!!this.labourSalaryTypeKeyno) {
            this.edit = (await this.datatask.Post(1423, { laboursalarytype_keyno: this.labourSalaryTypeKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(1424, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    laboursalarytype_keyno: number;
    labour_name: string;
    salarytype_name: string;
    salary_rate: string;
    calc_cost_rate: string;
}
